import React from 'react';
import logo from '../assets/logo-440.png';

const ContactCard = ({ children }) => {
  return (
    <article className="contact-card bg-primary-green-dark/30 backdrop-blur-xl rounded-2xl p-6 md:p-8 border border-primary-green-light/30 transition-all duration-300 hover:-translate-y-3">
      {children}
    </article>
  );
};

const Contact = () => {
  return (
    <React.Fragment>
      <section
        id="contact"
        className="contact pt-12 pb-6 md:pt-24 md:pb-8 px-[5%] bg-gradient-to-b from-primary-dark via-primary-green-dark to-primary-dark text-center"
      >
        <div className="contact-content max-w-3xl mx-auto mb-8 md:mb-16">
          <h2 className="section-title text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-8 bg-gradient-to-r from-white via-primary-green-light to-accent-gold bg-clip-text text-transparent" aria-label="Contact Yatin Patel at Jay Ambe Engineering GIDC Makarpura for CNC work and VMC work">
            Get In Touch
          </h2>
          <p className="text-lg md:text-xl mb-8 md:mb-10 text-primary-green-light/90">
            Ready to discuss your precision manufacturing needs?
          </p>
        </div>

        <div className="contact-grid grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12 max-w-5xl mx-auto">
          <ContactCard>
            <div className="flex justify-center mb-6">
              <img
                src={logo}
                alt="Jay Ambe Engineering precision machining company logo"
                width="440"
                height="400"
                loading="lazy"
                decoding="async"
                className="h-20 w-auto"
              />
            </div>

            <h3 className="text-xl md:text-2xl mb-4 text-white">
              <i className="fas fa-user-tie mr-2" aria-hidden="true"></i> Contact Person
            </h3>

            <p className="text-xl md:text-2xl my-4 text-primary-green-light">Yatin Patel</p>
            <p className="sr-only">Yatin Patel GIDC Makarpura contact for precision CNC work, precision VMC work and custom machined parts.</p>

            <address className="not-italic">
            <p className="mb-2 text-sm md:text-base text-primary-green-light/90">
              <i className="fas fa-envelope mr-2" aria-hidden="true"></i>
              <a
                href="mailto:jayambengineeringg@gmail.com"
                className="text-accent-gold hover:text-white transition-colors"
              >
                jayambengineeringg@gmail.com
              </a>
            </p>

            <p className="text-sm md:text-base text-primary-green-light/90">
              <i className="fas fa-phone mr-2" aria-hidden="true"></i>
              <a
                href="tel:+919898952052"
                className="text-accent-gold hover:text-white transition-colors"
              >
                9898952052
              </a>
            </p>
            </address>
          </ContactCard>

          <ContactCard>
            <h3 className="text-xl md:text-2xl mb-4 text-white">
              <i className="fas fa-map-marker-alt mr-2" aria-hidden="true"></i> Location
            </h3>

            <address className="not-italic mb-6 text-sm md:text-base text-primary-green-light/90 text-left">
              <p className="font-medium text-white mb-1">Jay Ambe Engineering</p>
              <p>989/16/2, near Bhumi Char Rasta</p>
              <p>Gayatri Krupa Ice Factory, Makarpura GIDC</p>
              <p>Makarpura, Vadodara, Gujarat 390014</p>
              <p>India</p>
              <a
                href="https://maps.google.com/?q=Jay+Ambe+Engineering%2C+989%2F16%2F2%2C+near+Bhumi+Char+Rasta%2C+Makarpura+GIDC%2C+Vadodara%2C+Gujarat+390014"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-3 text-accent-gold hover:text-white transition-colors"
              >
                Open in Google Maps
              </a>
            </address>

            <div className="map-container h-64 md:h-96 rounded-2xl overflow-hidden shadow-2xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19808.413941504074!2d73.17779101891662!3d22.256327752068675!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc578b362c181%3A0x9936144370a3f742!2sJay%20Ambe%20Engineering!5e0!3m2!1sen!2sin!4v1774186276087!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Jay Ambe Engineering location map"
              ></iframe>
            </div>
          </ContactCard>
        </div>
      </section>

      <footer className="bg-primary-dark text-center py-4 border-t border-white/10">
        <p className="text-primary-green-light/80 text-sm">
          &copy; 2026 Jay Ambe Engineering. All Rights Reserved.
        </p>
      </footer>
    </React.Fragment>
  );
};

export default Contact;
